export default "__VITE_ASSET__Dnd9Qi6Q__"